import { hasApiMenuPermission } from '@/libs/permissions';

// 通过 computed 计算属性，获取权限
// 当前模块使用过的权限，全部集中在这里，方便查看和维护
export default {
  computed: {
    // 权限 - 消息
    AUTH_MESSAGE_SETTING() {
      return hasApiMenuPermission('and', ['auth_message', 'auth_message_setting']);
    },

    // 权限 - 消息 - 处理所有消息
    AUTH_MESSAGE_HANDLE_ALL() {
      return hasApiMenuPermission('and', ['auth_message', 'auth_message_handle_all']);
    },

    // 权限 - 消息 - 处理单个
    AUTH_MESSAGE_HANDLE_ONE() {
      return hasApiMenuPermission('and', ['auth_message', 'auth_message_handle_one']);
    },

    // 权限 - 消息 - 清除消息
    AUTH_MESSAGE_CLEAR_UNREAD() {
      return hasApiMenuPermission('and', ['auth_message', 'auth_message_category_changeunread']);
    },
  },
};
